<div class="roaming">
    <stepper [steps]="steps()" />
    <back-navigation />
    <router-outlet />
</div>